import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularSection() {
  const popularComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

  const formatViews = (views: number) => {
    if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
    if (views >= 10000) return `${(views / 10000).toFixed(0)}万`;
    return views.toLocaleString();
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            人气排行榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            根据阅读量和用户评分综合排名的热门韩漫
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5" data-product-shop="">
          {popularComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex lg:flex-col items-center lg:items-stretch gap-4 lg:gap-0 bg-background-100 rounded-xl p-4 hover:bg-background-200/70 transition-all duration-300 cursor-pointer border border-background-200/60"
            >
              <div className="relative flex-shrink-0">
                <div className="w-16 h-20 sm:w-20 sm:h-28 lg:w-full lg:aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    title={comic.title}
                    loading="lazy"
                  />
                </div>
                <div className="absolute -top-1 -left-1 w-6 h-6 rounded-full bg-accent-500 text-background-50 text-xs font-bold flex items-center justify-center">
                  {idx + 1}
                </div>
              </div>
              <div className="flex-1 lg:mt-3 min-w-0">
                <div className="flex items-center gap-1.5 mb-1">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {comic.category}
                  </span>
                  <span className="text-xs text-foreground-400">{comic.status}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                    {comic.rating}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {formatViews(comic.views)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}